import React from "react";
import { Props } from "./types";
import { Resource } from "./resource";
import styles from "./styles.scss";

function ResourceList({ resources }: Props) {
  return (
    <div className={styles.resourceList}>
      <div className={styles.resources}>
        {resources.slice(0, 2).map((resource) => (
          <Resource resource={resource} />
        ))}
        {resources.length > 2 && (
          <p className={styles.hiddenTagsNbr}>+{resources.slice(2).length}</p>
        )}
      </div>
    </div>
  );
}

export { ResourceList };
